// ********************************************************
// Archive
// Handles asphalt-delivery archive loading/saving
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadDeliveries (params) {
  const res = await Backend.callApi({
    apiName: 'WorkPlace.LoadDeliveries',
    inputData: {
      // MITH special: If params is '' show all deliveries for all facilities (we use facility = null)
      Facility: params.facility === '' ? null : params.facility,
      workplaceSearch: params.workplaceSearch,
      customerSearch: params.customerSearch,
      showDeactivatedDeliveries: params.showDeactivatedDeliveries
    }
  })
  return res.data
}

export async function saveDeliveriesDetails (delivery) {
  const res = await Backend.callApi({
    apiName: 'WorkPlace.SaveDeliveriesDetails',
    inputData: {
      Deliveries: [delivery]
    }
  })
  return res
}

export async function reActivateDelivery (delivery, deActive) {
  const res = await Backend.callApi({
    apiName: 'WorkPlace.ReDeActivateDelivery',
    inputData: {
      Deliveries: [delivery],
      DeActive: deActive
    }
  })
  return res
}

/* export async function loadVehicles (param) {
  const res = await Backend.callApi({
    // apiName: 'Archive.LoadVehicles',
    apiName: 'CreateVehicles.LoadVehicles',
    inputData: {
      // MITH special: If facility is '' show all vehicles for all facilities (we use facility = null).
      Facility: param.facility === '' ? null : param.facility,
      SearchText: param.searchText,
      LoadDeleted: param.loadDeleted !== null ? param.loadDeleted : true // load Deleted, if we need to show all inactive Vehicles
    }
  })
  return res
} */

export async function loadZipCodes (param) {
  const res = await Backend.callApi({
    apiName: 'WorkPlace.LoadZipCodes',
    inputData: {
      // MITH special: If facility is '' show all vehicles for all facilities (we use facility = null).
      Facility: param.facility === '' ? null : param.facility,
      SearchText: param.searchText,
      LoadDeleted: param.loadDeleted !== null ? param.loadDeleted : false // load Deleted, if we need to show all inactive Vehicles
    }
  })
  return res
}

/* export async function loadVehicle (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadVehicle',
    inputData: {
      Facility: params.facilityNo,
      No: params.vehicleNo
    }
  })
  return res
} */

/* export async function saveVehiclesAndUsers (vehicle) {
  const res = await Backend.callApi({
    apiName: 'WorkPlace.SaveVehiclesAndUsers',
    inputData: {
      Vehicles: [vehicle]
    }
  })
  return res
} */

/* export async function isVehicleUser () {
  const res = await Backend.callApi({
    apiName: 'WorkPlace.IsVehicleUser',
    inputData: { }
  })
  return res
} */
